export default __webpack_public_path__ + "static/media/Boots of Baleful Blood.596547a5.jpg";